"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterConfig = require("react-router-config");
var _reactRouterDom = require("react-router-dom");
var _reactReduxLoadingBar = _interopRequireDefault(require("react-redux-loading-bar"));
var _reactErrorBoundary = require("react-error-boundary");
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _2 = require("..");
var _Translations = require("../Translations");
var _config = require("../config");
var _index = require("../config/index");
var _helpers = require("../helpers");
var _BottomNavigation = require("./components/BottomNavigation");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useChatModule = false;
try {
  useChatModule = Boolean(require('react-platform-chat/dist/Chat/Chat').default);
} catch (error) {}
var drawerWidth = 240;
function ErrorFallback(_ref) {
  var classes = _ref.classes,
    goBack = _ref.goBack;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.errorFallback,
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "secondary",
    className: classes.errorTitle,
    variant: "h1"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "ERREUR :(",
    defaultMessage: "ERREUR :("
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.errorContent_1,
    variant: "body1"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Une erreur s'est produite dans l'application et votre page n'a pas pu \xEAtre servie.",
    defaultMessage: "Une erreur s'est produite dans l'application et votre page n'a pas pu \xEAtre servie."
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.errorContent_2,
    variant: "body1"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Nous travaillons dur pour r\xE9soudre le probl\xE8me.",
    defaultMessage: "Nous travaillons dur pour r\xE9soudre le probl\xE8me."
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: goBack,
    className: classes.errorButton,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Page pr\xE9c\xE9dente",
    defaultMessage: "Page pr\xE9c\xE9dente"
  })));
}
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    appBar: {
      zIndex: theme.zIndex.mobileStepper,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: "calc(100% - ".concat(drawerWidth, "px)"),
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginLeft: 12,
      marginRight: 36
    },
    hide: {
      display: 'none'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap'
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerClose: _defineProperty({
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1
    }, theme.breakpoints.up('sm'), {
      width: 58
    }),
    drawerCloseWithoutIcons: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: 0
    },
    toolbar: _objectSpread({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px'
    }, theme.mixins.toolbar),
    content: {
      flexGrow: 1,
      padding: 0
    },
    errorFallback: {
      height: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    errorTitle: {
      marginBottom: '1.5rem',
      fontWeight: '500'
    },
    errorContent_1: {
      color: theme.palette.grey[600]
    },
    errorContent_2: {
      color: theme.palette.grey[700],
      marginTop: '.25rem',
      fontWeight: 'bold'
    },
    errorButton: {
      marginTop: '3rem'
    }
  };
};
var Layout = /*#__PURE__*/function (_React$Component) {
  _inherits(Layout, _React$Component);
  var _super = _createSuper(Layout);
  function Layout(props) {
    var _this;
    _classCallCheck(this, Layout);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleDrawerOpen", function () {
      _this.setState({
        open: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDrawerClose", function () {
      _this.setState({
        open: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleDrawerToggle", function () {
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      // Handle mobile size
      if (window.innerWidth < 600 && _this.state.open) {
        // close the drawer
        _this.handleDrawerClose();
      }
      // Handle non-mobile size
      if (window.innerWidth > 600 && !_this.state.open) {
        // open the drawer
        _this.handleDrawerOpen();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "routeSettingsCheck", function () {
      var matched = (0, _reactRouterConfig.matchRoutes)(_this.props.routes, _this.props.location.pathname)[0];
      if (matched && matched.route.settings) {
        var routeSettings = _lodash.default.merge({}, _this.props.defaultSettings, matched.route.settings);
        if (!_lodash.default.isEqual(_this.props.settings, routeSettings)) {
          var _routeSettings$layout, _routeSettings$layout2;
          if ((routeSettings === null || routeSettings === void 0 ? void 0 : (_routeSettings$layout = routeSettings.layout) === null || _routeSettings$layout === void 0 ? void 0 : (_routeSettings$layout2 = _routeSettings$layout.config) === null || _routeSettings$layout2 === void 0 ? void 0 : _routeSettings$layout2.bottomNavigation) !== false) {
            routeSettings.layout.config.bottomNavigation = true;
          }
          _this.props.dispatch({
            type: 'SET_SETTINGS',
            value: _lodash.default.merge({}, routeSettings)
          });
        }
      } else {
        if (!_lodash.default.isEqual(_this.props.settings, _this.props.defaultSettings)) {
          _this.props.dispatch({
            type: 'RESET_DEFAULT_SETTINGS'
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "toggleDrawer", function (event) {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      _this.handleDrawerClose();
    });
    _this.routeSettingsCheck();
    _this.state = {
      open: document.querySelector("body").offsetWidth > 600 // default closed on mobile size
    };

    // Window event for handling the screan size
    window.addEventListener("resize", _this.handleResize);
    return _this;
  }
  _createClass(Layout, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!_lodash.default.isEqual(this.props.location.pathname, prevProps.location.pathname)) {
        this.routeSettingsCheck();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_lodash.default.isEmpty(localStorage.getItem("user"))) {
        var params = {};
        if (!_lodash.default.isEmpty(_index.EMBED_USED_TO_FETCH_USER)) {
          params._embed = _toConsumableArray(_index.EMBED_USED_TO_FETCH_USER);
        }
        this.props.dispatch({
          type: "FETCH_USER",
          params: params
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames3,
        _classNames4,
        _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        extraProfilMenuItems = _this$props.extraProfilMenuItems,
        navigationConfig = _this$props.navigationConfig,
        theme = _this$props.theme,
        routes = _this$props.routes,
        user = _this$props.user,
        settings = _this$props.settings,
        successMessage = _this$props.successMessage,
        errorMessage = _this$props.errorMessage,
        _this$props$bottomBar = _this$props.bottomBarLinks,
        bottomBarLinks = _this$props$bottomBar === void 0 ? _config.SHOWN_ITEMS_IN_BOTTOM_BAR : _this$props$bottomBar;
      var isAuthenticated = Boolean(user.id);
      var customUserLinks = _lodash.default.sortBy(_lodash.default.map(user === null || user === void 0 ? void 0 : user.authorized_links, function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          title: item.name
        }, (0, _helpers.isUrl)(item.url) ? {
          component: "a"
        } : null);
      }), ["position"]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root
      }, /*#__PURE__*/_react.default.createElement(_reactReduxLoadingBar.default, {
        style: {
          position: 'fixed',
          backgroundColor: 'red',
          height: '3px',
          zIndex: 9000000
        }
      }), settings.layout.config.toolbar.display && /*#__PURE__*/_react.default.createElement(_core.AppBar, {
        position: "fixed",
        className: (0, _classnames.default)(classes.appBar, _defineProperty({}, classes.appBarShift, this.state.open))
      }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
        disableGutters: !this.state.open
      }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        color: "inherit",
        "aria-label": "Open drawer",
        onClick: this.handleDrawerOpen,
        className: (0, _classnames.default)(classes.menuButton, _defineProperty({}, classes.hide, this.state.open))
      }, /*#__PURE__*/_react.default.createElement(_Menu.default, null)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true,
        justify: "flex-end",
        alignItems: "center"
      }, _config.USE_NOTIFICATIONS_IN_TOP_BAR && isAuthenticated && /*#__PURE__*/_react.default.createElement(_2.Notifier, null), useChatModule && isAuthenticated && /*#__PURE__*/_react.default.createElement(_2.MessageNotifier, null), !_lodash.default.isEmpty(_Translations.OTHER_LANGUAGES) > 0 && /*#__PURE__*/_react.default.createElement(_2.LanguageSwitcher, {
        enabledLanguages: _lodash.default.uniq([_Translations.DEFAULT_LANGUAGE].concat(_toConsumableArray(_Translations.OTHER_LANGUAGES))),
        currentLanguage: this.props.locale
      }), /*#__PURE__*/_react.default.createElement(_2.ProfileMenu, {
        user: user,
        history: this.props.history,
        extraProfilMenuItems: extraProfilMenuItems
      })))), settings.layout.config.navbar.display && /*#__PURE__*/_react.default.createElement(_core.Drawer, {
        variant: window.innerWidth < 600 ? "temporary" : _config.CLOSE_DRAWER_WITHOUT_ICONS ? "persistent" : "permanent",
        className: (0, _classnames.default)(classes.drawer, (_classNames3 = {}, _defineProperty(_classNames3, classes.drawerOpen, this.state.open), _defineProperty(_classNames3, classes.drawerClose, !this.state.open && !_config.CLOSE_DRAWER_WITHOUT_ICONS), _defineProperty(_classNames3, classes.drawerCloseWithoutIcons, !this.state.open && _config.CLOSE_DRAWER_WITHOUT_ICONS), _classNames3)),
        classes: {
          paper: (0, _classnames.default)((_classNames4 = {}, _defineProperty(_classNames4, classes.drawerOpen, this.state.open), _defineProperty(_classNames4, classes.drawerClose, !this.state.open), _classNames4))
        },
        open: this.state.open
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.toolbar
      }, _config.NAVBAR_LOGO_PATH && /*#__PURE__*/_react.default.createElement(_core.Link, {
        href: _config.DEFAULT_LOCALE == this.props.locale ? "/" : "/".concat(this.props.locale)
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _config.NAVBAR_LOGO_PATH,
        alt: "",
        width: "125"
      })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
        onClick: this.handleDrawerToggle
      }, theme.direction === 'rtl' ? this.state.open ? /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null) : /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null) : this.state.open ? /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null) : /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null))), /*#__PURE__*/_react.default.createElement(_core.Divider, null), /*#__PURE__*/_react.default.createElement(_core.List, null, [].concat(_toConsumableArray(navigationConfig), _toConsumableArray(customUserLinks)).map(function (navigation) {
        // handle the role management by show or hide the item if the user has the role access to it.
        if (navigation.auth && user.roles.length > 0 && !navigation.auth.some(function (item) {
          return user.roles.includes(item);
        })) {
          return null;
        }
        if (navigation.type === 'item') {
          return /*#__PURE__*/_react.default.createElement(_2.NavItem, {
            selected: _this2.props.location.pathname === navigation.url,
            toggleDrawer: window.innerWidth < 600 ? _this2.toggleDrawer : null,
            key: navigation.id,
            item: navigation
          });
        }
        if (navigation.type === 'iframe') {
          return /*#__PURE__*/_react.default.createElement(_2.NavItem, {
            selected: _this2.props.location.pathname === navigation.url,
            toggleDrawer: window.innerWidth < 600 ? _this2.toggleDrawer : null,
            key: navigation.id,
            item: navigation
          });
        }
        if (navigation.type === 'local') {
          return /*#__PURE__*/_react.default.createElement(_2.NavItem, {
            selected: _this2.props.location.pathname === navigation.url,
            toggleDrawer: window.innerWidth < 600 ? _this2.toggleDrawer : null,
            key: navigation.id,
            item: navigation
          });
        }
        if (navigation.type === "external_same_page") {
          return /*#__PURE__*/_react.default.createElement(_2.NavItem, {
            selected: _this2.props.location.pathname === navigation.url,
            toggleDrawer: window.innerWidth < 600 ? _this2.toggleDrawer : null,
            key: navigation.id,
            item: navigation,
            component: "a"
          });
        }
        if (navigation.type === "external_new_tab") {
          return /*#__PURE__*/_react.default.createElement(_2.NavItem, {
            selected: _this2.props.location.pathname === navigation.url,
            toggleDrawer: window.innerWidth < 600 ? _this2.toggleDrawer : null,
            key: navigation.id,
            item: _objectSpread(_objectSpread({}, navigation), {}, {
              target: "_blank"
            }),
            component: "a"
          });
        }
        if (navigation.type === 'collapse') {
          return /*#__PURE__*/_react.default.createElement(_2.NavCollapse, {
            key: navigation.id,
            item: navigation
          });
        }
        if (navigation.type === 'divider') {
          return /*#__PURE__*/_react.default.createElement(_core.Divider, {
            key: navigation.id
          });
        }
        return null;
      }))), /*#__PURE__*/_react.default.createElement("main", {
        className: classes.content
      }, settings.layout.config.toolbar.display && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.toolbar
      }), /*#__PURE__*/_react.default.createElement(_reactErrorBoundary.ErrorBoundary, {
        FallbackComponent: function FallbackComponent() {
          return /*#__PURE__*/_react.default.createElement(ErrorFallback, {
            goBack: _this2.props.history.goBack,
            classes: classes
          });
        },
        resetKeys: [this.props.location.pathname],
        onError: function onError(error, errorInfo) {
          Sentry.captureException(error, {
            extra: errorInfo
          });
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "router-content"
      }, routes.map(function (route, index) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, _extends({
          key: index
        }, route));
      }))), (user === null || user === void 0 ? void 0 : user.id) && window.innerWidth < 600 && _index.SHOW_ITEMS_IN_BOTTOM_BAR && settings.layout.config.bottomNavigation !== false && /*#__PURE__*/_react.default.createElement(_BottomNavigation.BottomNavigation, {
        bottomBarLinks: customUserLinks
      })), /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        open: Boolean(errorMessage) || Boolean(successMessage),
        autoHideDuration: Boolean(errorMessage) ? null : 3000,
        onClose: function onClose() {
          if (Boolean(errorMessage)) {
            _this2.props.dispatch({
              type: 'CLEAR_ERROR'
            });
          } else {
            _this2.props.dispatch({
              type: 'CLEAR_SUCCESS_MESSAGE'
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_core.SnackbarContent, {
        style: errorMessage ? {
          backgroundColor: '#d32f2f'
        } : {
          backgroundColor: '#43a047'
        },
        message: /*#__PURE__*/_react.default.createElement("span", {
          id: "message-id",
          style: {
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'pre-line'
          }
        }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
          className: "pr-4 mr-2"
        }, errorMessage ? 'error' : 'check_circle'), errorMessage || successMessage),
        action: /*#__PURE__*/_react.default.createElement(_core.IconButton, {
          onClick: function onClick() {
            errorMessage ? _this2.props.dispatch({
              type: 'CLEAR_ERROR'
            }) : _this2.props.dispatch({
              type: 'CLEAR_SUCCESS_MESSAGE'
            });
          }
        }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
          style: {
            color: '#fff'
          }
        }, "close"))
      })));
    }
  }]);
  return Layout;
}(_react.default.Component);
Layout.propTypes = {
  classes: _propTypes.default.object.isRequired,
  theme: _propTypes.default.object.isRequired,
  routes: _propTypes.default.array.isRequired,
  user: _propTypes.default.object.isRequired
};
function mapStateToProps(state) {
  return {
    defaultSettings: state.settings.defaults,
    settings: state.settings.current,
    successMessage: state.successMessage.message,
    errorMessage: state.errorMessage.error,
    locale: state.localeReducer.locale
  };
}
var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})((0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Layout)));
exports.default = _default;